import { Dtos } from '#models';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fullName',
})
export class FullNamePipe implements PipeTransform {
  transform(value: Dtos.UserSimple | Dtos.SharedUser): string {
    return formatFullName(value);
  }
}
export function formatFullName(user: Dtos.UserSimple | Dtos.SharedUser): string {
  if (!user) {
    return '';
  }
  if ('FullName' in user) {
    return user.FullName;
  }
  if ('FirstName' in user) {
    return `${user.LastName ? user.LastName + ', ' : ''}${user.FirstName}${user.MiddleName ? ' ' + user.MiddleName : ''}`;
  }
  return '';
}
